module.exports = __webpack_public_path__ + "static/bg-tcc-aa08a0b0943a1b2692058e7c7aa4913e.jpg";